<!-- @format -->

<!-- ACCOUNT / CLIENT / BRANCH INFO (outside card) -->
<div class="context-info">
  <span *ngIf="currentRole === Roles.superAdmin"
    >Account: {{ selectedValues['company'].companyName }} &nbsp;|&nbsp;
  </span>
  Client: {{ selectedValues['plant'].plantName }} &nbsp;|&nbsp; Branch:
  {{ selectedValues['unit'].unitName }}
</div>

<div class="card custom-section">
  <div class="section-header">
    <div>
      <h1 class="section-title">Add a Form Field</h1>
      <p class="subtext">Fill out the form field details using the form below.</p>
    </div>
  </div>

  <form
    #form="ngForm"
    style="margin-top: 2rem"
    (ngSubmit)="!activateSubmitBtn() ? null : addDataPoint()"
  >
    <!-- DATA POINT NAME -->
    <div class="form-group col-1">
      <div>
        <label for="data_point_name" class="custom-label required"
          >Form Field Name</label
        >
        <input
          type="text"
          class="custom-input"
          name="data_point_name"
          id="data_point_name"
          minlength="3"
          maxlength="50"
          placeholder="Enter form field name"
          [(ngModel)]="addDataPointRequest.dataPointName"
        />
        <div *ngIf="!errorMessage.success" class="error">
          <img src="../../assets/alert.svg" alt="" />
          <p>{{ errorMessage.message }}</p>
        </div>
      </div>
    </div>

    <!-- DATA TYPE -->
    <div class="form-group col-1">
      <div>
        <label for="unit" class="custom-label required">Form Field Type</label>
        <app-dropdown
          [disabled]="false"
          [selectedItem]="selectedDataType"
          (onSelectOption)="setSelectedDataPointType($event)"
          [options]="dataTypes"
          [fields]="['id', 'dataPointType']"
          [form]="true"
          label="Choose Form Field Type"
        ></app-dropdown>
      </div>
    </div>

    <!-- UNIT OF MEASUREMENT -->
    <div class="form-group col-1" *ngIf="selectedDataType.dataPointType === 'Number'">
      <div>
        <label for="unit" class="custom-label required">Unit of Measurement</label>
        <input
          type="text"
          class="custom-input"
          placeholder="Enter unit of measurement"
          name="unit"
          id="unit"
          [(ngModel)]="addDataPointRequest.unitOfMeasurement"
        />
        <div *ngIf="!errorMessage.success" class="error">
          <img src="../../assets/alert.svg" alt="" />
          <p>{{ errorMessage.message }}</p>
        </div>
      </div>
    </div>

    <!-- DATE RANGE LABELS -->
    <div class="form-group col-2" *ngIf="selectedDataType.dataPointType === 'Date Range'">
      <div>
        <label for="date_range_start" class="custom-label">Start Date Label</label>
        <input
          type="text"
          class="custom-input"
          name="date_range_start"
          id="date_range_start"
          placeholder="Start Date"
          [(ngModel)]="dateRangeStartLabel"
        />
      </div>
      <div>
        <label for="date_range_end" class="custom-label">End Date Label</label>
        <input
          type="text"
          class="custom-input"
          name="date_range_end"
          id="date_range_end"
          placeholder="End Date"
          [(ngModel)]="dateRangeEndLabel"
        />
      </div>
    </div>

    <!-- REFERENCE NUMBER CONFIG -->
    <div class="form-group col-2" *ngIf="selectedDataType.dataPointType === 'Reference Number'">
      <div>
        <label for="refnum_prefix" class="custom-label">Prefix</label>
        <input
          type="text"
          class="custom-input"
          name="refnum_prefix"
          id="refnum_prefix"
          placeholder="REF-"
          [(ngModel)]="refnumPrefix"
        />
      </div>
      <div>
        <label for="refnum_padding" class="custom-label">Number Padding</label>
        <input
          type="number"
          min="1"
          max="12"
          class="custom-input"
          name="refnum_padding"
          id="refnum_padding"
          placeholder="4"
          [(ngModel)]="refnumPadding"
        />
      </div>
    </div>

    <!-- FILE UPLOAD CONFIG -->
    <div *ngIf="selectedDataType.dataPointType === 'File Upload'">
      <div class="form-group col-1">
        <div>
          <label for="file_types" class="custom-label">Allowed File Types</label>
          <input
            type="text"
            class="custom-input"
            name="file_types"
            id="file_types"
            placeholder="any, image, video, audio, media, or extensions e.g. pdf,png,jpg"
            [(ngModel)]="fileTypes"
          />
          <small class="form-text">
            Use a category (image, video, audio, media) or a comma-separated list of extensions.
          </small>
        </div>
      </div>
      <div class="form-group col-2">
        <div>
          <label for="file_max_files" class="custom-label">Max Files</label>
          <input
            type="number"
            min="1"
            class="custom-input"
            name="file_max_files"
            id="file_max_files"
            placeholder="1"
            [(ngModel)]="fileMaxFiles"
          />
        </div>
        <div>
          <label for="file_max_size" class="custom-label">Max Size (MB)</label>
          <input
            type="number"
            min="1"
            max="50"
            class="custom-input"
            name="file_max_size"
            id="file_max_size"
            placeholder="10"
            [(ngModel)]="fileMaxSizeMB"
          />
        </div>
      </div>
    </div>

    <!-- DURATION CONFIG -->
    <div *ngIf="selectedDataType.dataPointType === 'Duration'">
      <div class="form-group col-1">
        <div>
          <label for="duration_unit" class="custom-label">Unit</label>
          <select class="custom-input" name="duration_unit" id="duration_unit" [(ngModel)]="durationUnit">
            <option value="days">Days</option>
            <option value="hours">Hours</option>
            <option value="minutes">Minutes</option>
          </select>
        </div>
      </div>
      <div class="duration-info">
        <img src="../../assets/alert.svg" alt="" />
        <p>On the form, this field shows its own Start and End date inputs and
          automatically displays the elapsed time in the selected unit.</p>
      </div>
    </div>

    <!-- LIST OPTIONS -->
    <div
      class="form-group col-1 options-section"
      *ngIf="
        selectedDataType.dataPointType === 'List (Single Selection)' ||
        selectedDataType.dataPointType === 'List (Multiple Selection)' ||
        selectedDataType.dataPointType === 'Dropdown List'
      "
    >
      <div>
        <label class="custom-label">Options</label>
        <div
          class="option-row"
          [class.option-highlight]="highlightEmptyOption && optionsList[i].trim() === ''"
          *ngFor="let option of optionsList; let i = index; trackBy: trackByIndex"
        >
          <input
            type="text"
            class="custom-input"
            placeholder="Enter option"
            [ngModel]="optionsList[i]"
            (ngModelChange)="optionsList[i] = $event; onOptionChange()"
            [name]="'option_' + i"
          />
          <button
            type="button"
            class="btn-remove-option"
            *ngIf="optionsList.length > 1"
            (click)="removeOption(i)"
          >
            &times;
          </button>
        </div>
        <button
          type="button"
          class="btn-add-option"
          (click)="addOption()"
        >
          + Add option
        </button>
        <div *ngIf="validationErrorMessage" class="error">
          <img src="../../assets/alert.svg" alt="" />
          <p>{{ validationErrorMessage }}</p>
        </div>
      </div>
    </div>

    <!-- MIN / MAX -->
    <div
      class="form-group col-2"
      *ngIf="selectedDataType.dataPointType === 'Number'"
    >
      <div>
        <label for="data_point_min" class="custom-label required"
          >Form Field Min</label
        >
        <input
          type="number"
          class="custom-input"
          name="data_point_min"
          placeholder="Enter min"
          min="0"
          id="data_point_min"
          [(ngModel)]="addDataPointRequest.dataPointMin"
          onkeypress="return /^[0-9&.-]/g.test(event.key);"
        />
        <div *ngIf="!errorMessage.success" class="error">
          <img src="../../assets/alert.svg" alt="" />
          <p>{{ errorMessage.message }}</p>
        </div>
      </div>
      <div>
        <label for="data_point_max" class="custom-label required"
          >Form Field Max</label
        >
        <input
          type="number"
          class="custom-input"
          name="data_point_max"
          id="data_point_max"
          placeholder="Enter max"
          onkeypress="return /^[0-9&.-]/g.test(event.key);"
          [(ngModel)]="addDataPointRequest.dataPointMax"
        />
        <div *ngIf="!errorMessage.success" class="error">
          <img src="../../assets/alert.svg" alt="" />
          <p>{{ errorMessage.message }}</p>
        </div>
      </div>
    </div>

    <!-- UPLOAD CSV FOR Dropdown List -->
    <div
      *ngIf="selectedDataType.dataPointType === 'Dropdown List'"
      class="upload-container"
    >
      <label
        *ngIf="selectedDataType.dataPointType === 'Dropdown List'"
        class="bulk-upload-label"
      >
        <span
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
          "
          ><hr style="width: 100%; border: 1px solid #edf0f2" />
          <strong style="font-size: 0.9rem; margin: 0 10px">OR</strong>
          <hr style="width: 100%; border: 1px solid #edf0f2"
        /></span>
        Upload options in bulk</label
      >
      <div class="upload-box">
        <div class="upload-child-container">
          <button type="button" class="upload-btn" (click)="fileInput.click()">
            <span
              ><img src="../../../../assets/upload.svg" alt="upload icon" />
              Upload File</span
            >
          </button>
          <input
            type="file"
            #fileInput
            accept=".csv"
            hidden
            (change)="onFileSelected($event)"
          />
          <p type="button" style="font-size: 0.8rem">
            Not sure what to include?
            <span
              (click)="downloadSampleCsv()"
              style="color: green; cursor: pointer"
              >Download Sample CSV</span
            >
          </p>
        </div>
        <div class="file-info" *ngIf="selectedFile">
          <span style="font-size: 0.8rem">{{ selectedFile.name }}</span>
          <div
            style="
              display: flex;
              justify-content: start;
              align-items: start;
              width: 100%;
            "
          >
            <div class="progress-bar-container">
              <div
                class="progress-bar"
                [class.progressError]="uploadError"
                [style.width.%]="uploadProgress"
              ></div>
            </div>
            <span style="font-size: 0.8rem; margin-left: 1rem"
              >{{ uploadProgress }}%</span
            >
          </div>
        </div>
      </div>
      <div *ngIf="validationErrorMessage" class="error">
        <img src="../../assets/alert.svg" alt="" />
        <p>{{ validationErrorMessage }}</p>
      </div>
    </div>

    <!-- DESCRIPTION -->
    <div class="form-group col-1">
      <div>
        <label for="desc" class="custom-label">Description</label>
        <textarea
          name="data_point_description"
          id="data_point_description"
          cols="30"
          rows="10"
          placeholder="Type here"
          class="custom-input"
          [(ngModel)]="addDataPointRequest.dataPointDescription"
        >
        </textarea>
      </div>
    </div>

    <input
      type="hidden"
      name="company_is_deleted"
      id="company_is_deleted"
      [(ngModel)]="addDataPointRequest.isDeleted"
    />
    <input
      type="hidden"
      name="company_status"
      id="company_status"
      [(ngModel)]="addDataPointRequest.status"
    />
    <div class="btn-group">
      <button class="btn-outline" (click)="transferData()" routerLink="..">
        Cancel
      </button>
      <button
        type="submit"
        class="btn-fill"
        [ngClass]="!activateSubmitBtn() ? 'disabled-btn' : ''"
      >
        Add Form Field
      </button>
    </div>
  </form>
</div>
<app-success-toast *ngIf="toastService.showToast"></app-success-toast>
